import React from "react";
import { Route, Switch } from "react-router-dom";
import BasicInfo from "../pages/BasicInfo";
import OpeningTimes from "../pages/OpeningTimes";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import Authorities from "../../../auth/authorities";
import { getIsAuthorized } from "../../../utils/authorities";
import Location from "../pages/Location";
import DashboardIcon from "@material-ui/icons/Dashboard";
import Dashboard from "../pages/Dashboard";
import StorefrontIcon from "@material-ui/icons/Storefront";
import { Icon } from "@iconify/react";
import PaymentGateway from "../pages/PaymentGateway";
import UsersAndPermission from "../pages/UsersAndPermission";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import scheduledTaskConfiguration from "../pages/scheduledTaskConfiguration";
import ChainConfiguration from "../pages/ChainConfiguration";
import PostCodeLockUp from "../pages/PostCodeLockUp";
import LogsDetails from "../pages/LogsDetails";
import LicenseDetails from "../pages/LicenseDetails";
import PassLicense from "../pages/LicenseDetails/PassLicense";
import ChangeRequests from "../pages/ChangeRequests";
import ListIcon from "@material-ui/icons/List";
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import Integrations from "../pages/Integrations";
import IntegrationsRedirect from "../pages/IntegrationsRedirect";
// import { Icon } from "@iconify/react";

export const getSidebarRoutes = () => {
  const sidebarRoute = [
    {
      id: "DASHBOARD",
      title: "Dashboard",
      path: "",
      icon: <DashboardIcon />,
      isAuthorized: getIsAuthorized(Authorities.LOCATION_DASHBOARD_READ),
    },
    {
      id: "BASIC_INFO",
      title: "Business Info",
      path: "/basic-info",
      icon: <StorefrontIcon />,
      isAuthorized: getIsAuthorized(Authorities.BASIC_INFO_READ),
    },
    {
      id: "OPENING_TIMES",
      title: "Opening Times",
      path: "/opening-times",
      icon: <AccessTimeIcon />,
      isAuthorized: getIsAuthorized(Authorities.OPENING_TIME_READ),
    },
    {
      id: "POSTCODE_LOOKUP",
      title: "Postcode Lookup",
      path: "/postcode-lookup",
      icon: <AccessTimeIcon />,
      isAuthorized: getIsAuthorized(Authorities.OPENING_TIME_READ),
    },
    {
      id: "logsDetails",
      title: "Logs",
      path: "/logsDetails",
       icon: <span className="material-symbols-outlined">search_activity</span>,
      isAuthorized: getIsAuthorized(Authorities.INVENTORY_READ),
    },
   {
      id: "integrations",
      title: "Integrations",
      path: "/integrations",
       icon: <span className="material-symbols-outlined">search_activity</span>,
      isAuthorized: getIsAuthorized(Authorities.INVENTORY_READ),
    },
    {
      id: "internal",
      title: "Internal Configurations", 
      path: "/internalConfiguration",
      icon: <Icon icon="ri:admin-line" height="24" width="24" />,
      isAuthorized: getIsAuthorized(Authorities.STOCK_CONFIGURATION_READ),
      childRoutes: [
        {
          id: "internalConfiguration",
          title: "Payment Configuration",
          path: "/internalConfiguration/paymentConfiguration",
          icon: <Icon icon="dashicons:admin-generic" height="24" width="24" />,
          isAuthorized: getIsAuthorized(Authorities.PAYMENT_CONFIGURATION_READ),
        },
        {
          id: "USERS_PERMISSION",
          title: "Users & Permissions",
          path: "/internalConfiguration/users-permission",
          icon: <VerifiedUserIcon />,
          isAuthorized: getIsAuthorized(Authorities.STOCK_CONFIGURATION_READ),
        },
        {
          id: "CHAIN_CONFIGURATION",
          title: "Chain Configuration",
          path: "/internalConfiguration/chainConfiguration",
          icon: <AccessTimeIcon />,
          isAuthorized: getIsAuthorized(Authorities.PAYMENT_CONFIGURATION_READ),
        },
        {
          id: "SCHEDULED_TASK_CONFIGURATION",
          title: "Scheduled Task Configuration",
          path: "/internalConfiguration/scheduledTask",
          icon: <AssignmentTurnedInIcon />,
          isAuthorized: getIsAuthorized(Authorities.PAYMENT_CONFIGURATION_READ),
        },
        {
          id: "PASSES",
          title: "Passes",
          path: "/internalConfiguration/passes",
          icon: <InsertDriveFileIcon />,
          isAuthorized: getIsAuthorized(Authorities.LOCATION_LICENSE_READ),
        },
      ],
    },
    {
      id: "LicenseDetails",
      title: "Licenses & Subscriptions ",
      path: "/license/details",
      icon: <span className="material-symbols-outlined" style={{ color: "#ac3b52" }} >sync_lock</span>,
      isAuthorized: getIsAuthorized(Authorities.LOCATION_LICENSE_READ),
    },
    {
      id: "CHANGE_REQUESTS",
      title: "Change Requests",
      path: "/change-requests",
      icon: <ListIcon style={{ color: "#ac3b52" }} />, 
      isAuthorized: getIsAuthorized(Authorities.LOCATION_LICENSE_READ),
    },
  ];
  return sidebarRoute;
};

export interface LocationAppRoutesProps {}

const LocationAppRoutes: React.FunctionComponent<
  LocationAppRoutesProps
> = () => {
  return (
    <Switch>
      <Route path="/:locationId/presto-locations" component={Dashboard} exact />
      <Route
        path="/:locationId/presto-locations/opening-times"
        component={OpeningTimes}
      />
      <Route
        path="/:locationId/presto-locations/internalConfiguration/users-permission"
        component={UsersAndPermission}
      />
      <Route
        path="/:locationId/presto-locations/basic-info"
        component={BasicInfo}
      />
      <Route
        path="/:locationId/presto-locations/postcode-lookup"
        component={PostCodeLockUp}
      />
  
      <Route
        path="/:locationId/presto-locations/internalConfiguration/paymentConfiguration"
        component={PaymentGateway}
        exact
      />
      <Route
        path="/:locationId/presto-locations/internalConfiguration/chainConfiguration"
        component={ChainConfiguration}
        exact
      />
      <Route
        path="/:locationId/presto-locations/internalConfiguration/scheduledTask"
        component={scheduledTaskConfiguration}
        exact
      />
      <Route
        path="/:locationId/presto-locations/logsDetails"
        component={LogsDetails}
        exact
      />
      <Route path="/" component={Location} exact />
      <Route  path="/:locationId/presto-locations/license/details"
        component={LicenseDetails}
        exact
      />
      <Route
        path="/:locationId/presto-locations/internalConfiguration/passes"
        component={PassLicense}
        exact
      />
      <Route
        path="/:locationId/presto-locations/change-requests"
        component={ChangeRequests}
        exact
      />
      <Route
        path="/:locationId/presto-locations/integrations"
        component={Integrations}
        exact
      />
      {/* HubRise's one fixed redirect URL: "hubrise" is a fixed word, not a
          location id. The location comes from the OAuth state. */}
      <Route
        path="/hubrise/presto-locations/integrations/redirect"
        component={IntegrationsRedirect}
        exact
      />
    </Switch>
  );
};

export default LocationAppRoutes;
